module.exports = __webpack_public_path__ + "static/media/file-invoice.f864f7ac.svg";